/*
  Bâan Kumlaï — « Prévenez-moi quand c'est de retour ». 20/10/2026.

  Sur une fiche produit dont la taille choisie est épuisée, un encart propose à la
  cliente de laisser son email. La demande part par le FORMULAIRE DE CONTACT de la
  boutique (/contact), donc elle arrive dans baankumlai@gmail.com comme les autres
  messages, sans application tierce ni base de données à tenir.

  Le message est préfixé « RETOUR EN STOCK » pour être filtrable dans Gmail.
*/
(function () {
  'use strict';

  var CLE = 'bk_retour_stock_envoyes';
  var racine = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function styles() {
    if (document.getElementById('bk-retour-stock-css')) return;
    var s = document.createElement('style');
    s.id = 'bk-retour-stock-css';
    s.textContent = [
      '.bkrs{margin:14px 0 0;padding:14px;border:1px solid rgba(206,173,95,.5);border-radius:10px;background:rgba(206,173,95,.08)}',
      '.bkrs__titre{margin:0 0 4px;font-size:14px;font-weight:700;color:#5a4a21}',
      '.bkrs__txt{margin:0 0 10px;font-size:13px;line-height:1.4;color:#5f5848}',
      '.bkrs__ligne{display:flex;gap:8px;flex-wrap:wrap}',
      '.bkrs__email{flex:1 1 170px;min-width:0;padding:10px;border:1px solid rgba(90,74,33,.35);border-radius:6px;font-size:14px;background:#fff;color:#3b3325}',
      '.bkrs__btn{flex:0 0 auto;padding:10px 16px;border:0;border-radius:6px;background:#CEAD5F;color:#fff;font-size:12px;font-weight:700;letter-spacing:.4px;text-transform:uppercase;cursor:pointer}',
      '.bkrs__btn[disabled]{opacity:.55;cursor:default}',
      '.bkrs__msg{margin:9px 0 0;font-size:13px;line-height:1.4;color:#5a4a21}',
      '.bkrs__msg--ok{color:#2f6b45;font-weight:600}',
      '.bkrs__msg--ko{color:#9b2c2c}'
    ].join('');
    document.head.appendChild(s);
  }

  function dejaDemande(cle) {
    try { return (JSON.parse(sessionStorage.getItem(CLE) || '[]')).indexOf(cle) > -1; } catch (e) { return false; }
  }

  function noterDemande(cle) {
    try {
      var l = JSON.parse(sessionStorage.getItem(CLE) || '[]');
      l.push(cle);
      sessionStorage.setItem(CLE, JSON.stringify(l));
    } catch (e) {}
  }

  // Dawn désactive le bouton d'ajout et lui met le libellé « Épuisé ».
  // On part du BOUTON, pas du formulaire : la fiche contient plusieurs
  // form[action*="/cart/add"] et le premier du document ne contient pas le bouton.
  function bloc() {
    var bouton = document.querySelector('product-info button[name="add"]') ||
      document.querySelector('.product-form__buttons button[name="add"]') ||
      document.querySelector('button[name="add"]');
    if (!bouton) return null;
    var epuise = bouton.disabled || /épuisé|epuise|sold out/i.test(bouton.textContent || '');
    // On pose l'encart après un conteneur de type bloc, jamais dans une rangée flex.
    var ancre = bouton.closest('product-form') || bouton.closest('.product-form__buttons') || bouton.parentElement;
    return { ancre: ancre, bouton: bouton, epuise: epuise };
  }

  function infos() {
    var h = location.pathname.split('/products/')[1];
    var produit = (document.querySelector('h1') || {}).textContent || (h ? h.split('?')[0] : 'Produit');
    var taille = '';
    var choisi = document.querySelector('product-info input[type="radio"]:checked, product-info select');
    if (choisi) taille = choisi.value || '';
    if (!taille) {
      var actif = document.querySelector('product-info .product-form__input input:checked + label, product-info fieldset input:checked + label');
      if (actif) taille = actif.textContent.trim();
    }
    var variante = new URLSearchParams(location.search).get('variant') || '';
    return { produit: produit.trim(), taille: taille.trim(), variante: variante, url: location.origin + location.pathname + (variante ? '?variant=' + variante : '') };
  }

  function poser() {
    var b = bloc();
    if (!b) return;

    var existant = document.querySelector('.bkrs');
    if (!b.epuise) { if (existant) existant.remove(); return; }

    var i = infos();
    var cle = i.produit + '|' + i.taille;
    if (existant) {
      if (existant.getAttribute('data-cle') === cle) return;
      existant.remove();
    }

    var d = document.createElement('div');
    d.className = 'bkrs';
    d.setAttribute('data-cle', cle);
    var revientDEnvoi = /[?&]contact_posted=true/.test(location.search);
    if (revientDEnvoi || dejaDemande(cle)) {
      d.innerHTML = '<p class="bkrs__msg bkrs__msg--ok">C\'est noté : nous vous écrivons dès que cette taille revient.</p>';
    } else {
      var corps = "RETOUR EN STOCK - demande d'alerte\n\n" +
        'Produit : ' + i.produit + '\n' +
        'Taille : ' + (i.taille || 'non precisee') + '\n' +
        'Page : ' + i.url + '\n\n' +
        'Merci de prevenir cette cliente des le reassort.';
      d.innerHTML =
        '<p class="bkrs__titre">Cette taille est momentanément épuisée</p>' +
        '<p class="bkrs__txt">Nos joncs sont fabriqués à la main en Thaïlande. Laissez-nous votre email : vous serez prévenue dès son retour, avant la mise en ligne.</p>' +
        '<form class="bkrs__form" method="post" action="' + racine + 'contact#bkrs" accept-charset="UTF-8">' +
        '<input type="hidden" name="form_type" value="contact">' +
        '<input type="hidden" name="utf8" value="✓">' +
        '<input type="hidden" name="contact[Nom]" value="Alerte retour en stock">' +
        '<input type="hidden" name="contact[Commentaire]">' +
        '<div class="bkrs__ligne">' +
        '<input class="bkrs__email" type="email" name="contact[email]" inputmode="email" autocomplete="email" placeholder="votre@email.fr" aria-label="Votre adresse email" required>' +
        '<button class="bkrs__btn" type="submit">Me prévenir</button>' +
        '</div>' +
        '<p class="bkrs__msg" hidden></p>' +
        '</form>';
        d.querySelector('[name="contact[Commentaire]"]').value = corps;
    }
    b.ancre.insertAdjacentElement('afterend', d);
  }

  function envoyer(e, d) {
    var champ = d.querySelector('.bkrs__email');
    var msg = d.querySelector('.bkrs__msg');
    var email = (champ.value || '').trim();

    if (!/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(email)) {
      e.preventDefault();
      msg.hidden = false;
      msg.textContent = 'Merci de vérifier votre adresse email.';
      msg.className = 'bkrs__msg bkrs__msg--ko';
      champ.focus();
      return;
    }

    // Shopify refuse le POST en AJAX (403) : on laisse le navigateur envoyer le
    // formulaire, il revient sur la fiche avec ?contact_posted=true.
    noterDemande(d.getAttribute('data-cle') || '');
    msg.hidden = false;
    msg.textContent = 'Envoi…';
    msg.className = 'bkrs__msg';
  }

  function demarrer() {
    if (location.pathname.indexOf('/products/') === -1) return;
    styles();
    poser();

    document.addEventListener('submit', function (e) {
      var f = e.target.closest && e.target.closest('.bkrs__form');
      if (!f) return;
      envoyer(e, f.closest('.bkrs'));
    });

    // Dawn re-rend la fiche à chaque changement de taille.
    new MutationObserver(function () { poser(); })
      .observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
})();
